<template>
  <div class="tab-contents">
    <TabContent
      v-for="item in items"
      :id="item.id"
      :key="item.id"
      :active="isActive(item.id)"
    >
      <slot :name="item.id" />
    </TabContent>
  </div>
</template>
<script>
import TabContent from '../../atoms/tab/TabContent.vue'

export default {
  components: {
    TabContent
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    activeTab: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    isActive(value) {
      return this.activeTab === value
    }
  }
}
</script>
<style lang="scss" scoped>
.tab-contents {
  max-width: 1040px;
  margin: auto;
}
</style>
